export const successCode = 200;
export const createSuccessCode = 201;
